import _ from 'lodash';
import qs from 'qs';
import {
  HOMEPAGE,
  LANDING_PAGE,
  SEARCH,
  BOOKING,
  BOOKING_CHECK,
  BOOKING_CONFIRMATION,
  ABOUT,
  CONTACT,
  HOST,
  REVIEWS_NEW,
  REVIEWS_SUCCESS,
} from './pageTypes';
import type { PageTypes } from './pageTypes';
import I18n from '../../config/i18n';

const pathPrefix = `/:lang(${I18n.supportedLocales.join('|')})`;

const pageToPath: { [key: string]: string } = {
  [HOMEPAGE]: '',
  [LANDING_PAGE]: 'specials/:slug',
  [SEARCH]: 'search',
  [BOOKING]: 'processing/booking/costs',
  [BOOKING_CHECK]: 'processing/booking/overview',
  [BOOKING_CONFIRMATION]: 'processing/booking/reserved',
  [ABOUT]: 'your_benefits',
  [CONTACT]: 'contact',
  [HOST]: ':host',
  [REVIEWS_NEW]: 'reviews/:invitationCode/new',
  [REVIEWS_SUCCESS]: 'reviews/success',
};

const pathToPage = _.invert(pageToPath);

export function getPathForPage(pageType: PageTypes): string {
  return pageToPath[pageType];
}

export function getPageForPath(path = ''): PageTypes | undefined {
  const strippedPrefix = path.replace(`${pathPrefix}`, '').replace(/^\//, '');
  const page = pathToPage[strippedPrefix];
  return page != null ? (page as PageTypes) : undefined;
}

function generatePathFor(pageType: PageTypes, params: any = {}, lang = I18n.locale): string {
  const path = getPathForPage(pageType);
  const interpolatedPath = `/${lang}/${path.replace(/:(\w+)/, (m, name) => params[name] || name)}`;
  if (params.query && !_.isEmpty(params.query)) {
    const query =
      typeof params.query === 'object'
        ? qs.stringify(params.query, { arrayFormat: 'brackets' })
        : params.query;
    return `${interpolatedPath}?${query}`;
  }
  return interpolatedPath;
}

export function isPath(pageType: PageTypes, path: string): boolean {
  return new RegExp(`\\/\\w{2}\\/${getPathForPage(pageType).replace(/:\w+/, '\\w+')}`).test(path);
}

export function getHomepagePath(lang = I18n.locale): string {
  return generatePathFor(HOMEPAGE, {}, lang);
}

export function getLandingpagePath(slug: string, lang = I18n.locale): string {
  return generatePathFor(LANDING_PAGE, { slug }, lang);
}

export function getSearchPath(query = {}, lang = I18n.locale): string {
  return generatePathFor(SEARCH, { query }, lang);
}

export function getBookingPath(lang = I18n.locale): string {
  return generatePathFor(BOOKING, {}, lang);
}

export function getBookingCheckPath(lang = I18n.locale): string {
  return generatePathFor(BOOKING_CHECK, {}, lang);
}

export function getBookingConfirmationPath(lang = I18n.locale): string {
  return generatePathFor(BOOKING_CONFIRMATION, {}, lang);
}

export function getAboutPath(lang = I18n.locale): string {
  return generatePathFor(ABOUT, {}, lang);
}

export function getContactPath(lang = I18n.locale): string {
  return generatePathFor(CONTACT, {}, lang);
}

export function getReviewsNewPath(lang = I18n.locale): string {
  return generatePathFor(REVIEWS_NEW, {}, lang);
}

export function getReviewsConfirmationPath(lang = I18n.locale): string {
  return generatePathFor(REVIEWS_SUCCESS, {}, lang);
}
